<div *ngIf="!init" style="align-self: center">
  <mat-spinner style="margin: auto" color="primary" diameter="48"></mat-spinner>
</div>

<div class="edit-project" *ngIf="init">
  <div class="actions-button">
    <button
      class="menu-button"
      (click)="openActions()"
      type="button"
      mat-button
    >
      Acties
    </button>

    <button
      class="menu-button"
      (click)="openNotificationMailModal()"
      type="button"
      mat-button
    >
      Mail
    </button>

    <button
      *ngIf="!generatingPlacementSticker"
      class="menu-button"
      (click)="generatePlacementSticker()"
      type="button"
      mat-button
    >
      Plakbrief
    </button>

    <div
      *ngIf="generatingPlacementSticker"
      style="align-self: center; margin-bottom: 5px"
    >
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </div>

    <button
      class="menu-button"
      (click)="deleteSubProject()"
      type="button"
      mat-button
      [disabled]="disableDelete || model.id == null"
    >
      Verwijder
    </button>
  </div>

  <mat-card
    class="align-summary-tabs mat-elevation-z0"
    style="margin-left: 5px"
  >
    <adjustment-project-summary
      [subproject]="model"
      [project]="project"
    ></adjustment-project-summary>
  </mat-card>

  <!-- PROJECT sectie-->

  <div
    class="align-project-tabs underline upper-space"
    style="margin-left: -10px"
    *ngIf="!isHiddenProject"
  >
    <div class="container">
      <div *ngIf="!client">
        <div
          class="sub-project-banner-container"
          [ngClass]="bannerContainerClass"
        >
          <div class="sub-project-banner">
            <span>
              <span class="sub-project-banner-title">
                {{ subProjectTitle }}
              </span>

              <span *ngIf="model.currentCreatedAt != null">
                - aanvraag ({{ model.currentCreatedAt | date : 'dd/MM/yyyy' }})
              </span>
            </span>

            <div class="d-flex" *ngIf="model.projectUser">
              <div
                class="banner-employee-initials rounded-circle in-the-middle"
                [matTooltip]="getUserName(model.projectUser)"
              >
                <span
                  *ngIf="!model.projectUser?.profilePicture"
                  class="initials-font-size user-display"
                >
                  {{ getUserLetters(model.projectUser) }}
                </span>

                <span
                  *ngIf="model.projectUser?.profilePicture"
                  class="user-display"
                >
                  <img
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      model.projectUser.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="fullLength">
        <mat-card class="mat-elevation-z0">
          <ex-edit-adjustment
            [subproject]="this.model"
            [project]="project"
            [client]="client"
            (output)="saveExAdjustment()"
          >
          </ex-edit-adjustment>
        </mat-card>

        <mat-card
          *ngIf="!client && model.type !== 'Repo'"
          class="mat-elevation-z0 internal-form"
        >
          <general-internal-adjustment
            [adjustment]="this.model"
            [project]="project"
            (output)="saveGeneralInternalAdjustment()"
          >
          </general-internal-adjustment>
        </mat-card>

        <mat-card *ngIf="!client" class="mat-elevation-z0 internal-form">
          <in-edit-adjustment
            [subproject]="this.model"
            [project]="project"
            (output)="saveInAdjustment()"
          >
          </in-edit-adjustment>
        </mat-card>
      </div>
    </div>
  </div>
</div>
